import useNotificationsStore from '@/stores/notifications';

const AUTO_CLOSE_MS = 5000;

export default function handleRequestError(error, { path, params, payload } = {}) {
  if (error?.name === 'AbortError') return;
  if (String(path || '') === '/state') return;

  const notificationsStore = useNotificationsStore();
  const { addNotification, closeNotification } = notificationsStore;

  const closable = true;

  const id = addNotification({
    type: 'error',
    message: error?.message || 'Request failed',
    detail: { path, params, payload },
    closable,
  });

  if (closable) {
    window.setTimeout(() => closeNotification(id), AUTO_CLOSE_MS);
  }
}
